/**
 * Frontend UI configuration API
 *
 * NO MOCKUP CODE - Real API endpoints only
 */

import apiClient from './client';
import type { TrainingDefaults } from '@/types/training';
import type { UiConfig } from '@/types/ui';

export async function getUiConfig(): Promise<UiConfig> {
  const response = await apiClient.get<{ data?: UiConfig } | UiConfig>(
    '/api/v1/frontend/ui-config'
  );
  const payload = (response.data as { data?: UiConfig }).data ?? response.data;
  return payload as UiConfig;
}

export async function getTrainingDefaults(): Promise<TrainingDefaults> {
  const response = await apiClient.get<
    { data?: TrainingDefaults } | TrainingDefaults
  >('/api/v1/frontend/training-defaults');
  const payload =
    (response.data as { data?: TrainingDefaults }).data ?? response.data;
  return payload as TrainingDefaults;
}
